import React from "react";
import type { RedirectRequest as BaseRedirectRequest, EndSessionRequest, PopupRequest } from "@azure/msal-browser";

export type RedirectRequest = BaseRedirectRequest & {
    targetUrl?: string;
};

type AuthContext = {
    isAuthenticated: boolean;
    user: { name: string, picture?: string };
    roles: string[];
    allowedTags: string[];
    deniedTags: string[];
    effectiveTags: string[];
    userMetadata: {
        // Non-standard claim names, as returned originally by the "getUserMetadata" function call...
        EmailAddress: string;
        UserId: string;
        // Standardized claims...
        domain: string;
        tenant_name: string;
        roles: string[];
        allowedTags: string[];
        deniedTags: string[];
        effectiveTags: string[];
        user_id: string;
        name: string;
        email: string;
        // User metadata...
        [key: string]: any;
    },
    loading: boolean;
    error: string;
    loginWithPopup: (request?: PopupRequest | undefined) => void;
    handleRedirectPromise: (hash?: string | undefined) => void;
    onRedirectCallback: (options: any) => void;
    getIdTokenClaims: (p: any) => any;
    loginWithRedirect: (request?: Partial<RedirectRequest> | undefined) => void;
    getTokenSilently: () => Promise<string | void>;
    getTokenWithPopup: (request?: PopupRequest | undefined) => void;
    logout: (request?: EndSessionRequest | undefined) => void;
};

export const Auth0Context = React.createContext<AuthContext>(null);
export const useAuth0: () => AuthContext = () => React.useContext(Auth0Context);